import { render } from "./District.vue?vue&type=template&id=77769940&ts=true"
import script from "./District.vue?vue&type=script&lang=ts"
export * from "./District.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__